import { Box, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import moment from "moment/moment";
import { CardContainerRetro } from "../Container/CardContainerRetro";
import { IconEyeFilled } from "@tabler/icons-react";
import { IconAwardFilled } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import MetricStatus from "../MetricStatus/MetricStatus";

export const CardPostBig = ({
	thread,
	date,
	rd = 8,
	borderType = "full",
	isMobile,
}) => {
	const { i18n } = useTranslation();
	const theme = useTheme();

	return (
		<CardContainerRetro w={"100%"} h={336.62} rd={rd} borderType={borderType}>
			<Box
				sx={{
					padding: isMobile ? theme.spacing(1, 1.5) : theme.spacing(1.5, 2),
					width: "100%",
					backgroundColor: theme.palette.background.paper,
					display: "flex",
					flexDirection: "column",
					gap: theme.spacing(3),
					borderRadius: theme.spacing(0.5),
				}}
			>
				<Stack spacing={0}>
					<Box
						sx={{
							display: "flex",
							flexDirection: "row",
							justifyContent: "space-between",
							height: 20,
						}}
					>
						<Stack direction="row" spacing={0.5} alignItems="center">
							<Typography
								variant={isMobile ? "body2" : "body1"}
								sx={{
									fontWeight: 500,
									lineHeight: 1,
									color: theme.palette.text.secondary,
								}}
							>
								{moment(date).locale(i18n.language).format("MM/DD")}
							</Typography>
							<Typography
								variant={isMobile ? "body2" : "body1"}
								sx={{
									fontWeight: 500,
									lineHeight: 1,
									color: theme.palette.text.secondary,
								}}
							>
								{moment(date).locale(i18n.language).format("ddd")}
							</Typography>
						</Stack>
						<Stack direction="row" spacing={0.25} alignItems="center" sx={{ color: theme.palette.text.secondary }}>
							{thread.viewRank < 4 && (
								<IconEyeFilled color={theme.palette.text.primary} size={18} />
							)}
							{thread.engagementRank < 4 && (
								<IconAwardFilled color={theme.palette.text.primary} size={18} />
							)}
						</Stack>
					</Box>
					<a href={thread.permalink} target="_blank" rel="noreferrer">
						<Typography
							sx={{
								fontFamily: '"source-han-serif-korean", "Noto Serif KR", "Noto Serif CJK KR", "Source Han Serif KR", "Apple SD Gothic Neo", "Malgun Gothic", "맑은 고딕", serif',
								lineHeight: 1.55,
								fontSize: isMobile ? "1rem" : "1.125rem",
								color: theme.palette.text.primary,
								height: isMobile ? 44 : 52,
								fontWeight: 900,
								marginBottom: isMobile ? theme.spacing(3) : theme.spacing(6),
								width: isMobile ? "100%" : "calc(100% - 16px)",
								overflow: "hidden",
							}}
						>
							{thread.text.split(".")[0].replace(/�/g, "")}
						</Typography>
						<Typography
							sx={{
								lineHeight: 1.55,
								fontSize: isMobile ? "0.875rem" : "1rem",
								color: theme.palette.text.primary,
								height: isMobile ? `${0.875 * 1.55 * 3}rem` : `${1 * 1.55 * 3}rem`,
								fontWeight: 600,
								width: isMobile ? "100%" : "calc(100% - 16px)",
								overflow: "hidden",
								display: "-webkit-box",
								WebkitLineClamp: 3,
								WebkitBoxOrient: "vertical",
							}}
						>
							{thread.text
								.split(".")
								.slice(1)
								.join(".")
								.replace(/�/g, "")
								.trim()}
						</Typography>
					</a>
				</Stack>
				<Stack direction="row" spacing={isMobile ? 0 : 1} sx={{ color: theme.palette.text.secondary, flexWrap: "wrap" }}>
					<MetricStatus
						w={isMobile ? "50%" : "auto"}
						isMobile={isMobile}
						type={"view"}
						value={thread.views}
					/>
					<MetricStatus
						w={isMobile ? "50%" : "auto"}
						isMobile={isMobile}
						type={"like"}
						value={thread.likes}
					/>
					<MetricStatus
						w={isMobile ? "50%" : "auto"}
						isMobile={isMobile}
						type={"reply"}
						value={thread.replies}
					/>
					<MetricStatus
						w={isMobile ? "50%" : "auto"}
						isMobile={isMobile}
						type={"repost"}
						value={thread.reposts}
					/>
				</Stack>
			</Box>
		</CardContainerRetro>
	);
};
